const getEventDetails = async (eventDetailsDomain: string) => {
  try {
    const response = await fetch(`${eventDetailsDomain}/api/v1/event.details.json`);
    return await response.json();
  } catch (err) {
    console.error(err);
  }
};

export default { getEventDetails };
